var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"reserved-text wordWrap",style:(_vm.styleObject)},[_vm._v(" Copyright ©️ 2023 - "+_vm._s(_vm.year)+" The HKCCCU Logos Academy. All rights reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }